import { FC } from 'react'
import { ClockIcon, DocumentDuplicateIcon, DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline'
import theme from 'theme'
import {
  EmptyStateContainer,
  EmptyStateDescription,
  EmptyStateIconCircle,
  EmptyStateTitle
} from './customTemplates.styles'

export type TemplatesEmptyStateVariant = 'default' | 'search' | 'scheduled' | 'unscheduled'

interface TemplatesEmptyStateProps {
  variant: TemplatesEmptyStateVariant
}

const VARIANT_CONFIG: Record<
  TemplatesEmptyStateVariant,
  { icon: typeof DocumentDuplicateIcon; title: string; description: string }
> = {
  default: {
    icon: DocumentDuplicateIcon,
    title: 'No Templates Yet',
    description: 'Nothing here yet.\nBuild a custom template to match your workflow.'
  },
  search: {
    icon: DocumentMagnifyingGlassIcon,
    title: 'No Results Found',
    description: 'No templates here — yet.\nTry broadening your search or explore available templates.'
  },
  scheduled: {
    icon: ClockIcon,
    title: 'No Scheduled Reports',
    description: 'Set up a report schedule to stay up to date.'
  },
  unscheduled: {
    icon: ClockIcon,
    title: 'No Unscheduled Reports',
    description: 'There are no unscheduled reports.\nEvery report already has an active schedule.'
  }
}

const TemplatesEmptyState: FC<TemplatesEmptyStateProps> = ({ variant }) => {
  const { icon: Icon, title, description } = VARIANT_CONFIG[variant]

  return (
    <EmptyStateContainer>
      <EmptyStateIconCircle>
        <Icon width={48} height={48} stroke={theme.colors.dustyRoseGray} />
      </EmptyStateIconCircle>
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateDescription>{description}</EmptyStateDescription>
    </EmptyStateContainer>
  )
}

export default TemplatesEmptyState
